import { useEnv } from "contexts/Env"
import { useLocale } from "contexts/Locale"
import { useEffect, useRef, useState } from "react"

import { KILL_DURATION, KILL_ROUTE, LAUNCH_DURATION, LAUNCH_ROUTE, STEPS, TRANSIT_DELAY } from "./constants"
import { mvSubscribe, useWatchVariations } from "./context"
import { focusCta, logmine } from "./utils"

const mapSolrVariations = item => {
  return ["model", "material", "bezel", "bracelet", "dial"].reduce((a, v) => {
    let vitem = item[`variations_modelpage_${v}`]
    const o = Object.create(null)
    if (!!vitem && vitem.length > 1) o[v] = vitem.join(",")
    return Object.assign(a, o)
  }, Object.create(null))
}

const buildJourneyByStep = (stepindex, vars) => {
  const updateJourneyState = (a, v) => {
    let does_exist = !!vars[v]
    let is_alone = does_exist && !~vars[v].indexOf(",")
    return !!a && !!a.length ? a : does_exist && !is_alone ? v : ""
  }

  let nextlist = STEPS.slice(stepindex + 1)
  let prevlist = STEPS.slice(0, stepindex)
  prevlist.reverse()

  return {
    prev: prevlist.reduce(updateJourneyState, "") || "family",
    next: nextlist.reduce(updateJourneyState, "") || "family",
  }
}

const buildJourney = item => {
  const res = {
    prev: [],
    next: [],
    sindex: [],
  }
  let journey = {}
  let sindex = 0
  let last = 0
  let next = 0

  STEPS.map((v, i) => {
    journey = buildJourneyByStep(i, item.vars)
    res.prev.push(STEPS.indexOf(journey.prev))
    res.next.push(STEPS.indexOf(journey.next))
  })

  res.smap = STEPS.reduce((a, v) => {
    const _v = v //v === "model" ? "size" : v
    let does_exist = item.vars[v]
    if (!does_exist) does_exist = item.vars[_v]
    let is_alone = !!does_exist && !~does_exist.indexOf(",")
    return [a, +(!!does_exist && !is_alone)].join("")
  }, "")

  res.sindex = res.next.map(v => {
    next = v > last ? sindex++ : sindex
    last = v
    return next
  })

  return { ...item, ...res }
}

export const mapSolrResults = item => {
  const specs = item.watch.docs[0]

  return buildJourney({
    uid: specs.rmc,
    family: specs.family,
    familyCode: specs.familyCode,
    name: specs.name,
    nameCode: specs.nameCode,
    category: (specs.facet_global_category || []).join(""),
    newmodelselection: specs.newmodelselection,
    variations: item.variations,
    variationsCtaImage_cl: item.variationsCtaImage_cl,
    vars: Object.assign(mapSolrVariations(item), { discover: specs.rmc }),
    cardid: `${specs.nameCode}/${specs.part_material_id}`,
    specs: [
      specs.spec_case,
      specs.spec_diameter,
      specs.family,
      specs.name,
      specs.spec_material,
      specs.spec_bezel,
      specs.spec_bracelet,
      specs.spec_dial,
      `/watches/${specs.familyCode}/${specs.rmc}`,
      specs.newmodelselection,
    ],
    assets: {
      bezel: specs.part_case_id,
      dial: specs.part_dial_file_name,
      material: specs.part_material_id,
      shadow: specs.part_shadow_file_name,
      bracelet: specs.rmc,
    },
  })
}

export function useResults(route, family, collection, catready, incard) {
  const rffamily = useRef(null)
  const locale = useLocale()
  const env = useEnv()
  async function update(v) {
    if (!v || incard) return catready.set(true)
    if (rffamily.current === family.get()) return
    catready.set(false)

    const variableHost = process.browser ? env.services : process.env.SERVICE_CATALOG_URL
    const query = `${variableHost}/api/catalog/variations/global?language=${locale.current.codes.www}&family=${family.get()}`

    const results = await fetch(new Request(query))
      .then(response => response.json())
      .then(data => data.results.map(mapSolrResults))
      .catch(e => { })

    collection.set(results)
    rffamily.current = family.get()
    catready.set(true)
  }

  useEffect(() => mvSubscribe("Route useResults", route, update), [])
}
